import React from 'react'

import { SchemaCustomfield } from '@/__generated/es-api'
import Dialog, { DialogProps } from '@/app/component/atom/dialog'
import DialogHeader from '@/app/component/atom/dialog-header'

import UpdateCustomFieldForm from './form/update-custom-field-form'

type Props = DialogProps & {
  customField: SchemaCustomfield
  onClose: () => void
}

const UpdateCustomFieldDialog: React.FC<Props> = ({ customField, onClose, ...props }) => (
  <Dialog {...props}>
    <DialogHeader title="Update custom field" onClose={onClose} />
    <UpdateCustomFieldForm customField={customField} onExit={onClose} />
  </Dialog>
)

export default UpdateCustomFieldDialog
